import Vue from 'vue'
import alt_texts from '@/mixins/alt_texts'
Vue.mixin(alt_texts)
